<template>
  <div
    ref="h5BestdealerPublicity"
    class="h5-bestdealer-publicity"
    @click="openIntercom()"
  >
    <div
      class="h5-bestdealer-publicity-section"
      v-for="(section, index) of sections"
      :key="index"
    >
      <img
        class="h5-bestdealer-publicity-section__image"
        :src="section.image"
      >
      <p class="h5-bestdealer-publicity-section__title">
        {{ section.title }}
      </p>
    </div>
    <Icon
      class="h5-bestdealer-publicity__arrow"
      name="arrow-right-l-2"
    />
    <Teleport
      to="body"
      v-if="show"
    >
      <div
        class="h5-bestdealer-publicity-servicer"
      >
        <div class="h5-bestdealer-publicity-servicer__logo">
          <img
            src="@/assets/publicity/servicer.png"
            alt="Customer Service"
          >
          <p class="h5-bestdealer-publicity-servicer__time">
            7*24
          </p>
        </div>
        <div>
          <p class="h5-bestdealer-publicity-servicer__title">
            Hi~, Didn’t find it?
          </p>
          <p class="h5-bestdealer-publicity-servicer__subtitle">
            Ask your Agent — FREE.
          </p>
        </div>
        <Button
          class="h5-bestdealer-publicity-servicer__button"
          type="primary"
          @click="openIntercom"
        >
          Contact Us
        </Button>
        <img
          class="h5-bestdealer-publicity-servicer__close"
          src="@/assets/publicity/close.svg"
          @click="show = false"
        >
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { Icon } from '../Icon'
import LogoCustomizationImage from '@/assets/publicity/logo-customization-m.png'
import TailoredFulfillmentImage from '@/assets/publicity/tailored-fulfillment-m.png'
import { useIntercom } from '@/hooks/useIntercom'
import { useContactUs } from './useContactUs'
import { Button } from '../Button'

const { showNewMessage } = useIntercom()

const elRef = useTemplateRef('h5BestdealerPublicity')

const { show } = useContactUs(elRef)

const sections = [
  {
    image: LogoCustomizationImage,
    title: 'Logo Customization'
  }, {
    image: TailoredFulfillmentImage,
    title: 'Tailored Fulfillment'
  }
]

const openIntercom = () => {
  show.value = false
  showNewMessage()
}
</script>

<style lang="less" scoped>
.h5-bestdealer-publicity {
  display: flex;
  align-items: center;
  padding: 8px;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(90deg, #0DA3A3 -6.87%, #295FCC 22.26%, #5252E5 51.4%, #295FCC 80.53%, #0DA3A3 109.67%);

  &-section {
    display: flex;
    align-items: center;
    gap: 6px;

    + .h5-bestdealer-publicity-section {
      margin-left: 16px;
    }

    &__image {
      width: 32px;
      height: 32px;
    }

    &__title {
      color: #FFF;
      font-family: mon-600;
      font-size: 12px;
      line-height: 16px;
    }
  }

  &__arrow {
    margin-left: auto;
    font-size: 14px;
    color: #FFF;
  }

  &-servicer {
    position: fixed;
    left: 16px;
    right: 16px;
    bottom: 8px;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
    border-radius: 32px;
    border: 1px solid #EBF1F5;
    background:
      linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%),
      linear-gradient(90deg, rgba(231, 173, 255, 0.48) 0%, rgba(194, 231, 247, 0.48) 50%, rgba(199, 235, 228, 0.48) 100%),
      white;

    &__logo {
      flex-shrink: 0;
      position: relative;
      width: 38px;
      height: 38px;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    &__time {
      position: absolute;
      top: -8px;
      right: -24px;
      padding: 0 6px;
      border-radius: 7px 7px 7px 0;
      background: #D3E1FD;
      color: #1B3E9C;
      font-family: mon-600;
      font-size: 10px;
      line-height: 14px;
    }

    &__title {
      color: #232323;
      font-family: mon-600;
      font-size: 14px;
      line-height: 18px;
    }

    &__subtitle {
      color: #232323;
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
    }

    &__button {
      margin-left: auto;
      width: 82px;
      height: 24px;
      background-color: #232323;
      font-size: 12px;
      line-height: 16px;
    }

    &__close {
      position: absolute;
      top: -20px;
      right: 12px;
    }
  }
}
</style>
